import { render, staticRenderFns } from "./SoleTrader.vue?vue&type=template&id=133ba493"
import script from "./SoleTrader.vue?vue&type=script&lang=js"
export * from "./SoleTrader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports